import React, { useState } from "react";
import { ListItem, ListItemSecondaryAction } from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import clsx from "clsx";
import classes from "../../../../css/modules/navigation.module.scss";
import { Text } from "../../../Text";
import { SubMenu } from "./SubMenu";

export const Item = ({ item, onMenuClick, pathName }) => {
  const active = pathName === item.href;
  const [open, setOpen] = useState(false);
  const onClick = () => {
    setOpen(!open);
    onMenuClick(item);
  };
  return (
    <>
      <ListItem
        data-testid="mn_menu_item"
        button
        key={item.text}
        className={clsx(classes.menuItem, active && classes.menuItemActive)}
        onClick={onClick}
      >
        {item.icon && <span className={clsx(item.icon, classes.icon)} />}
        <span>
          <Text value={item.text} />
        </span>

        <Tooltip title={item.statusTooltip}>
          <ListItemSecondaryAction onClick={() => onBaselineDeleteClick(i.PK_Project)}>  
            {item.showWarning && <span className={clsx("ico icon-warning", classes.icon)} style={{ color: "orange" }} />}
            {item.showError && <span className={clsx("ico icon-warning", classes.icon)} style={{ color: "red" }} />}
          </ListItemSecondaryAction>
        </Tooltip>

      </ListItem>
      <SubMenu open={open} items={item.subItems} onMenuClick={onMenuClick} pathName={pathName} />
    </>
  );
};
